module.exports = __webpack_public_path__ + "static/media/black_joker.3c0cbeff.png";